import { BrowserStorage } from '@atc/browser-storage';

/**
 * This function retrieves consumer insights data from local storage
 * and returns an object with the relevant attributes.
 *
 * @returns {Object} An object containing mapped attributes from consumer insights.
 */
export default function getConsumerInsights() {
  if (typeof window === 'undefined') {
    // Return early if window is not defined (e.g., in a server-side environment)
    return {};
  }
  const consumerInsights = new BrowserStorage('consumer_insights', {
    persist: true
  });
  const {
    insights = {},
    metadata = {}
  } = consumerInsights.getItem() || {};
  return {
    MkOfPrefMdl: insights.makeOfPreferredModel || '',
    PrefMdl: insights.preferredModel || '',
    PrefMdlConf: insights.preferredModelConfidence || '',
    MkOfSecPrefMdl: insights.makeOfSecondPreferredModel || '',
    SecPrefMdl: insights.secondPreferredModel || '',
    MktLevel: insights.marketLevel || '',
    PrefPrice: insights.preferredPrice || '',
    PrefVehType: insights.preferredVehicleType || '',
    PriceSensitivity: insights.priceSensitivity || '',
    PrefMk: insights.preferredMake || '',
    PrefBstyl: insights.preferredBodystyle || '',
    FixedOps: insights.fixedOps !== undefined ? insights.fixedOps.toString() : '',
    PrefMileage: insights.preferredMileage || '',
    RecPrefMk: insights.recentActivityPreferredMake || '',
    RecPrefMdl: insights.recentActivityPreferredModel || '',
    MkOfRecPrefMdl: insights.makeOfRecentActivityPreferredModel || '',
    trackingId: metadata.trackingId || ''
  };
}